import { useState } from "react";
import { Box, Card, IconButton, Typography } from "@mui/material";
import {
  MapOutlined as MapOutlinedIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";
import ContactMapPanel from "../addressbook/panels/ContactMapPanel";

const STORAGE_KEY = "match:interestMapCard:collapsed";

const InterestMapCard = ({ contact, onSaveInterests }) => {
  const [collapsed, setCollapsed] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "false"); } catch { return false; }
  });
  const toggle = () => setCollapsed((prev) => {
    const next = !prev;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch {}
    return next;
  });

  return (
    <Card sx={{ borderRadius: 2, boxShadow: "0 1px 2px rgba(0,0,0,0.04)", overflow: "hidden", mb: 1 }}>
      <Box
        onClick={toggle}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1.25,
          py: 0.75,
          cursor: "pointer",
          backgroundColor: "#F8FAFC",
          borderBottom: collapsed ? "none" : "1px solid #E2E8F0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <MapOutlinedIcon sx={{ fontSize: 16, color: "#1D4ED8" }} />
          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>Interest Map</Typography>
        </Box>
        <IconButton size="small" sx={{ color: "#64748B", p: 0.35 }}>
          {collapsed ? <ExpandMoreIcon sx={{ fontSize: 16 }} /> : <ExpandLessIcon sx={{ fontSize: 16 }} />}
        </IconButton>
      </Box>
      {!collapsed ? (
        <ContactMapPanel contact={contact} embedded onSaveInterests={onSaveInterests} />
      ) : null}
    </Card>
  );
};

export default InterestMapCard;
